// import { EffectsModule } from '@ngrx/effects';
import { InjectionToken, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { StoreModule } from '@ngrx/store';
import { StoreRouterConnectingModule, RouterStateSerializer } from '@ngrx/router-store';
// eslint-disable-next-line import/no-extraneous-dependencies
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ServiceWorkerModule } from '@angular/service-worker';

import { GoogleTagManagerModule } from 'angular-google-tag-manager';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { LayoutsModule } from './core/layouts/layouts.module';
import { CustomRouterStateSerializer } from './settings/custom-router-state-serializer';
import { reducers } from './core/store/reducers';
import { CoreModule } from './core/core.module';
import { EffectsModule } from '@ngrx/effects';
import { effects } from './core/store/effects';
import { LoaderModule } from './shared/components/loader/loader.module';
// import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';

export const PROMOReducerToken = new InjectionToken('PROMO-PORTAL Registered Reducers');

export const RouterSerializerProvider = [
  { provide: RouterStateSerializer, useClass: CustomRouterStateSerializer },
];

export function getReducers() {
  return reducers;
}

export const ReducerProvider = [{ provide: PROMOReducerToken, useFactory: getReducers }];

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    CoreModule,
    BrowserModule,
    HttpClientModule,
    HttpClientJsonpModule,
    IonicModule.forRoot({
      platform: {
        /** The default `desktop` function returns false for devices with a touchscreen.
        * This is not always wanted, so this function tests the User Agent instead.
        **/
        'desktop': (win) => {
          const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(win.navigator.userAgent);
          return !isMobile;
        }
      },
    }
    ),
    RouterModule,
    AuthModule,
    StoreModule.forRoot(PROMOReducerToken, {}),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot(effects),
    LayoutsModule,
    LoaderModule,
    !environment.production
      ? StoreDevtoolsModule.instrument({
        maxAge: 25, // Retains last 25 states
        logOnly: environment.production, // Restrict extension to log-only mode
      })
      : [],
    // ModalOfflineModule,
    GoogleTagManagerModule.forRoot({
      id: environment.production ? 'GTM-TXDML4V' : 'GTM-P9CLMTP',
    }),
    ServiceWorkerModule.register('/sw-promoportal.js', { enabled: environment.production }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ReducerProvider,
    // {provide: ErrorHandler, useClass: RavenErrorHandler },
    // StatusBar,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
